import Mock from '@/mocks/Mock'
import RainRuiHistory, { RainRuiHistoryAttributes } from '@/models/RainRuiHistory'
import { RainRuiHistoryParams } from '@/repositories/rain-rui-history-repository'

export default class RainRuiHistoryMock extends Mock<RainRuiHistoryAttributes> {
  constructor() {
    super('rain_rui_history')
  }

  get(params: RainRuiHistoryParams) {
    console.log(params)

    return new RainRuiHistory(this.data)
  }
}
